// extracted by mini-css-extract-plugin
export const hero = "hero-module--hero--aIzll";
export const image = "hero-module--image--1aUwF";
export const content = "hero-module--content--__Vm1";
export const logo = "hero-module--logo--1DM9h";